import { render, staticRenderFns } from "./PendingEditRequestWordValues.vue?vue&type=template&id=5d5fa0ab&"
import script from "./PendingEditRequestWordValues.vue?vue&type=script&lang=js&"
export * from "./PendingEditRequestWordValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports